import { UserData } from './EventAttendees'
import Icon from '../assets'
import UserAvatar from '../User/UserAvatar'
import classNames from 'classnames'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  isPastEvent: boolean
  attendeeCount?: number
  attendees?: UserData[]
  isLoggedInUserAttendee?: boolean
  isEventEngagementEnabled: boolean
}

const getDesktopPhrase = (signupAllowed: boolean, isUserAttending: boolean, attendeeCount: number): string => {
  if (signupAllowed) {
    if (isUserAttending) {
      if (!attendeeCount) {
        return 'events.attending.you'
      }
      return 'events.attending.you.member'
    }
    return 'events.attending.member'
  }

  if (isUserAttending) {
    if (!attendeeCount) {
      return 'events.attended.you'
    }
    return 'events.attended.you.member'
  }

  return 'events.attended.member'
}

const EventAttendeesPreview = ({ isPastEvent = false, attendeeCount, attendees, isLoggedInUserAttendee, isEventEngagementEnabled }: Props) => {
  if (!isEventEngagementEnabled) return null
  if (!attendeeCount || !attendees || attendeeCount === 0 || attendees.length === 0) return null

  if (isLoggedInUserAttendee) {
    attendees = attendees.filter(attendee => attendee.id.toString() !== window.inSidedData.user.userid)
  }

  const desktopCount = isLoggedInUserAttendee && attendeeCount ? attendeeCount - 1 : attendeeCount
  const desktopPhrase = getDesktopPhrase(!isPastEvent, isLoggedInUserAttendee || false, desktopCount)

  return (
    <div className='event-item__attendees'>
      {
      isLoggedInUserAttendee
        ? <div className='event-item__attendee self'>
          <Icon icon='checkmark' size={24} />
        </div>
        : null
    }
      {
      attendees.map((attendee, i) => <div
        key={attendee.name} className={classNames(
          'event-item__attendee',
          { 'is-hidden-mobile-only': i + (isLoggedInUserAttendee ? 1 : 0) >= 3 },
          { 'is-hidden-mobile-up': i + (isLoggedInUserAttendee ? 1 : 0) >= 5 }
        )}
                                     >
        <UserAvatar user={attendee} />
      </div>)
    }
      <span className='metadata-desktop'><Phrase p={desktopPhrase} m='Forum' count={{ n: `${desktopCount}` }} /></span>
      <span className='metadata-mobile'>{attendeeCount} <Phrase p='events.attendees' m='Forum' /></span>
      <span className='metadata-featured'>{attendeeCount}</span>
    </div>
  )
}

export default EventAttendeesPreview
